import type {WorkAttractiveConditionType} from '../../../core/entities/company/schema';
import type {
  Company,
  EngineerCompany,
} from '../../../core/repositories/companyRepository';

type ConvertedCompany = {
  id: number;
  name: string;
  backgroundImg: string;
  logoImg: string;
  followCount: number;
  isFollowed: boolean;
  isHiring: boolean;
  foundedYear: number;
  employeeCount: number;
  catchPhrase: string;
  workAttractiveConditions: WorkAttractiveConditionType[];
};

const isEngineerCompany = (
  company: Company | EngineerCompany,
): company is EngineerCompany => {
  return 'backgroundImageUrls' in company;
};

export const convertCompany = (
  company: Company | EngineerCompany,
): ConvertedCompany => {
  const isEngineer = isEngineerCompany(company);

  const backgroundImg = isEngineer
    ? company.backgroundImageUrls['640x268']
    : company.backgroundImageURLs['640x268'];

  const logoImg = isEngineer
    ? company.logoUrls['140x105']
    : (company.logoURLs['140x105'] ?? '/next-image/reportAnalytics/about1.png');

  const followCount = isEngineer ? company.followCount : company.followerCount;

  const isFollowed = isEngineer ? company.followed : company.isFollowed;
  return {
    id: company.id,
    name: company.name,
    backgroundImg,
    logoImg,
    followCount,
    isFollowed,
    isHiring: company.isHiring,
    foundedYear: company.foundedYear,
    employeeCount: company.employeeCount,
    catchPhrase: company.catchPhrase,
    workAttractiveConditions: company.workAttractiveConditions ?? [],
  };
};
